import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getRotaVoltar } from '@/shared/utils/rotaVoltar';

export default function Page404() {
  const location = useLocation();
  const navigate = useNavigate();

  // Só redireciona um nível acima quando o usuário chegou aqui pelo botão Voltar do breadcrumb
  useEffect(() => {
    const fromVoltar = (location.state as { fromVoltar?: boolean } | null)?.fromVoltar;
    if (fromVoltar && location.pathname !== '/') {
      const rotaVoltar = getRotaVoltar(location.pathname);
      navigate(rotaVoltar, { replace: true });
    }
  }, [location.pathname, location.state, navigate]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 bg-light">
      <h1 className="display-1 fw-bold text-primary m-0" title="404">
        404
      </h1>
      <h2 className="h3 text-secondary mt-3 mb-2" title="Página não encontrada">
        Página não encontrada
      </h2>
      <p
        className="text-muted mb-4"
        title="Desculpe, a página que você procura não existe ou foi movida."
      >
        Desculpe, a página que você procura não existe ou foi movida.
      </p>
      <Link
        to="/"
        className="btn btn-primary px-4 py-2 fw-medium shadow"
        title="Voltar para a página inicial"
      >
        Voltar para a página inicial
      </Link>
    </div>
  );
}
